"use client";

import React from "react";
import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "La visión arquitectónica de Rudich Group superó todas nuestras expectativas. No solo construyen edificios, crean hitos urbanos con una calidad constructiva impecable.",
  author: "Alejandro Martínez",
  role: "Inversor Inmobiliario",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631017/img/testimonial_user_1.png"
}, {
  quote: "Confiar mi capital a Rudich Group fue la mejor decisión financiera del año. Su asesoramiento en rentabilidad y conocimiento del mercado argentino es inigualable.",
  author: "Sofía Valenzuela",
  role: "Consultora de Negocios",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631017/img/testimonial_user_2.png"
}, {
  quote: "El nivel de detalle en las terminaciones y el cumplimiento estricto de los plazos de entrega demuestran un profesionalismo que rara vez se ve en el sector.",
  author: "Ricardo Gómez",
  role: "Propietario en Puerto Madero",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631017/img/testimonial_user_3.png"
}, {
  quote: "Como arquitecto, valoro la honestidad estructural y el diseño vanguardista. Rudich Group logra una fusión perfecta entre estética moderna y funcionalidad.",
  author: "Elena Rodríguez",
  role: "Arquitecta Independiente",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631017/img/testimonial_user_4.png"
}, {
  quote: "Transparencia total desde el primer contacto. La seguridad jurídica que brindan en cada proyecto de inversión nos da la tranquilidad que buscamos.",
  author: "Marcos Benítez",
  role: "Director de Fondo de Inversión",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1631017/img/testimonial_user_5.png"
}];
const marqueeItems = [...testimonials, ...testimonials];
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="237826" id="testimonials" className="bg-[#0F2533] py-24 lg:py-32 overflow-hidden relative">
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          display: flex;
          width: max-content;
          animation: marquee 40s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `
    }} />

      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 md:mb-24 text-center max-w-3xl mx-auto">
          
          <h2 className="font-default text-4xl font-bold leading-tight uppercase !text-center !font-serif !text-[hsl(42,50%,70%)] md:text-5xl lg:text-6xl">LO QUE DICEN NUESTROS CLIENTES</h2>
        </div>

        <div ref={ref} className={`transition-all duration-1000 ease-out relative ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="relative overflow-hidden">
            <div className="animate-marquee flex gap-6">
              {marqueeItems.map((testimonial, i) => <div key={i} data-index={i} className="w-[320px] md:w-[450px] flex-shrink-0">
                  <Card className="text-card-foreground gap-6 border border-[#e6cd93]/30 rounded-3xl overflow-hidden p-8 h-full flex flex-col items-center text-center backdrop-blur-md !bg-[hsl(0,0%,100%)] md:p-12">
                    <div className="flex gap-1 mb-6">
                      {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="w-4 h-4 fill-[#e6cd93] text-[#e6cd93]" />)}
                    </div>
                    
                    <Quote className="w-10 h-10 text-primary/10 mb-4 absolute top-8 left-8 hidden md:block" />
                    
                    <CardContent className="p-0 flex flex-col h-full">
                      <p className="font-serif text-lg leading-relaxed italic mb-8 flex-grow !text-[hsl(0,0%,0%)] md:text-xl">
                        "{testimonial.quote}"
                      </p>
                      
                      <div className="flex flex-col items-center mt-auto">
                        <div className="w-16 h-16 rounded-lg overflow-hidden mb-4 border-2 border-primary/30">
                          <img src={testimonial.image} alt={testimonial.author} className="w-full h-full object-cover" />
                        </div>
                        <h4 className="font-default text-lg font-bold uppercase tracking-wider !text-[hsl(0,0%,0%)]">
                          {testimonial.author}
                        </h4>
                      </div>
                    </CardContent>
                  </Card>
                </div>)}
            </div>
            
            {}
            <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-[#0F2533] to-transparent z-10 pointer-events-none" />
            <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-[#0F2533] to-transparent z-10 pointer-events-none" />
          </div>
        </div>
      </div>
    </section>;
}